export function getAllHSCategories(axiosPrivate) {
  return axiosPrivate.get('/master-data/get-hs-categories')
}

export function importDataMapping(axiosPrivate, formData) {
  return axiosPrivate.post('/master-data/import-hs-category-mapping', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function deleteHSCategory(axiosPrivate, id) {
  return axiosPrivate.delete(`/master-data/delete-hs-category/${id}`)
}
